module.exports = __webpack_public_path__ + "static/Gtech-50d157c490e3c92293949ecbd9687583.mp4";